/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FavoritesWrapper_viewer = {
    readonly tradeFirmsDisplayMode?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly publicProfile: {
            readonly portfoliosInflated: ReadonlyArray<{
                readonly items: {
                    readonly numberOfPages: number | null;
                    readonly totalResults: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly item: {
                                readonly serviceId: string | null;
                                readonly firstPhotoWebPath: string | null;
                                readonly title: string | null;
                                readonly seller: {
                                    readonly serviceId: string | null;
                                } | null;
                                readonly isContemporary: boolean | null;
                                readonly isCustomizable: boolean | null;
                                readonly isNewAndMadeToOrder: boolean | null;
                                readonly classification: {
                                    readonly categories: ReadonlyArray<{
                                        readonly category: {
                                            readonly key: string | null;
                                            readonly browseUrl: string | null;
                                        } | null;
                                    } | null> | null;
                                } | null;
                                readonly pricing: {
                                    readonly amount: {
                                        readonly amount: number | null;
                                    } | null;
                                    readonly netPrice: {
                                        readonly amount: number | null;
                                    } | null;
                                    readonly salePrice: {
                                        readonly amount: number | null;
                                    } | null;
                                } | null;
                                readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly name: string | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly tradeFirmsEditMode?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly members: ReadonlyArray<{
            readonly userId: string | null;
        } | null> | null;
        readonly publicProfile: {
            readonly portfoliosInflated: ReadonlyArray<{
                readonly items: {
                    readonly numberOfPages: number | null;
                    readonly totalResults: number | null;
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly item: {
                                readonly serviceId: string | null;
                                readonly firstPhotoWebPath: string | null;
                                readonly title: string | null;
                                readonly seller: {
                                    readonly serviceId: string | null;
                                } | null;
                                readonly isContemporary: boolean | null;
                                readonly isCustomizable: boolean | null;
                                readonly isNewAndMadeToOrder: boolean | null;
                                readonly classification: {
                                    readonly categories: ReadonlyArray<{
                                        readonly category: {
                                            readonly key: string | null;
                                            readonly browseUrl: string | null;
                                        } | null;
                                    } | null> | null;
                                } | null;
                                readonly pricing: {
                                    readonly amount: {
                                        readonly amount: number | null;
                                    } | null;
                                    readonly netPrice: {
                                        readonly amount: number | null;
                                    } | null;
                                    readonly salePrice: {
                                        readonly amount: number | null;
                                    } | null;
                                } | null;
                                readonly " $fragmentRefs": FragmentRefs<"ItemTile_item">;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
                readonly name: string | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "FavoritesWrapper_viewer";
};
export type FavoritesWrapper_viewer$data = FavoritesWrapper_viewer;
export type FavoritesWrapper_viewer$key = {
    readonly " $data"?: FavoritesWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FavoritesWrapper_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "urlLabel",
    "variableName": "firmUrlLabel"
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "amount",
    "args": null,
    "storageKey": null
  }
],
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "portfoliosInflated",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioV2",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 60
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "favoritesPage"
            }
          ],
          "concreteType": "PortfolioItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "numberOfPages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalResults",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioItemV2",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "item",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Item",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "firstPhotoWebPath",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "size",
                              "value": "thumb"
                            }
                          ],
                          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "title",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "seller",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Seller",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isContemporary",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isCustomizable",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "isNewAndMadeToOrder",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "classification",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemClassification",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "categories",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ItemCategory",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "category",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "Category",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "key",
                                      "args": null,
                                      "storageKey": null
                                    },
                                    {
                                      "kind": "ScalarField",
                                      "alias": null,
                                      "name": "browseUrl",
                                      "args": null,
                                      "storageKey": null
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "pricing",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ItemPricing",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "amount",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v2/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "netPrice",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v2/*: any*/)
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "salePrice",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "FinancialAmount",
                              "plural": false,
                              "selections": (v2/*: any*/)
                            }
                          ]
                        },
                        {
                          "kind": "FragmentSpread",
                          "name": "ItemTile_item",
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "isTrade",
                              "variableName": "isTrade"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "FavoritesWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "favoritesPage",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isEditMode",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "tradeFirmsDisplayMode",
          "name": "tradeFirms",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "TradeFirmType",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isEditMode",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "tradeFirmsEditMode",
          "name": "tradeFirms",
          "storageKey": null,
          "args": (v0/*: any*/),
          "concreteType": "TradeFirmType",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "members",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmMemberType",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "userId",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            (v3/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f511d074d17de87c5d663130396038b7';
export default node;
